/*  MUI  */
import { Grid, Paper, Tab } from '@mui/material';

/* Shared */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { GlobalView } from 'application/Shared/Views';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import Add from './Pages/Add';
import List from './Pages/List';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false, tab: 'add' };
    }

    componentDidMount() {
        this.setState({ loaded: true });
    }

    handleTabChange = (value) => {
        this.setState({ tab: value });
    };

    render() {
        const { t } = this.props;
        const { loaded, tab } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <GlobalView page="globalAdminVendorIncidents">
                {tab === 'list' && (
                    <PageTitle title={t('Common.vendor_incidents')} />
                )}
                {tab === 'add' && <PageTitle title={t('VendorIncident.add')} />}

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <MUITabsWrapper
                            value={tab}
                            onChange={(_e, v) => this.handleTabChange(v)}
                        >
                            <Tab
                                value="add"
                                label={t('VendorIncident.add')}
                                aria-label="Add vendor incident"
                                data-trackid="globalAdmin_vendorIncidents_add"
                            />
                            <Tab
                                value="list"
                                label={t('VendorIncident.list')}
                                aria-label="See vendor incidents list"
                                data-trackid="globalAdmin_vendorIncidents_seeList"
                            />
                        </MUITabsWrapper>
                    </Grid>
                </Grid>

                <Paper elevation={0} variant="outlined">
                    <Grid container spacing={3}>
                        {tab === 'add' && (
                            <Grid item xs={12}>
                                <Add
                                    handleTabChange={(v) =>
                                        this.handleTabChange(v)
                                    }
                                />
                            </Grid>
                        )}
                        {tab === 'list' && (
                            <Grid item xs={12}>
                                <List />
                            </Grid>
                        )}
                    </Grid>
                </Paper>
            </GlobalView>
        );
    }
}
export default withTranslation()(Dashboard);
